(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-list-carousel')) {
    class ProductListCarousel extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.destroy();
      }

      init() {
        if (this.ready || !this.isConnected) return;

        this.track = this.querySelector('[data-rl-track]');
        if (!this.track) return;

        this.ready = true;
        this.TOL = 4; // px tolerance for sub-pixel rounding
        this.viewport = this.querySelector('[data-rl-viewport]');
        this.slides = Array.from(this.track.querySelectorAll('[data-rl-slide]'));
        this.prevBtn = this.querySelector('[data-rl-prev]');
        this.nextBtn = this.querySelector('[data-rl-next]');
        this.bar = this.querySelector('[data-rl-bar]');
        this.dotsEl = this.querySelector('[data-rl-dots]');
        this.toggleBtn = this.querySelector('[data-rl-toggle]');
        this.showMoreBtn = this.querySelector('[data-rl-show-more]');

        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.speed = Math.max(1, Number(this.dataset.speed) || 5) * 1000;

        this.mobileMq = window.matchMedia('(max-width: 749px)');
        this.reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.userPaused = this.reducedMq.matches; // respect reduced motion
        this.holds = new Set(); // hover / keyboard focus / touch
        this.inView = true;
        this.pageVisible = !document.hidden;
        this.count = 0;
        this.timer = null;
        this.raf = null;

        this.ac = new AbortController();
        const signal = this.ac.signal;

        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => { this.prev(); this.schedule(); }, { signal });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => { this.next(); this.schedule(); }, { signal });
        }
        if (this.dotsEl) {
          this.dotsEl.addEventListener('click', (e) => {
            const dot = e.target.closest('[data-rl-dot]');
            if (!dot) return;
            this.goTo(Number(dot.dataset.rlDot));
            this.schedule();
          }, { signal });
        }
        if (this.toggleBtn) {
          this.toggleBtn.addEventListener('click', () => this.setUserPaused(!this.userPaused), { signal });
        }
        if (this.showMoreBtn) {
          this.showMoreBtn.addEventListener('click', () => this.showMore(), { signal });
        }

        // Pause while hovering / touching the slides or keyboard-focusing inside
        if (this.viewport) {
          this.viewport.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'mouse') this.setHold('hover', true);
          }, { signal });
          this.viewport.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') this.setHold('hover', false);
          }, { signal });
          this.viewport.addEventListener('touchstart', () => this.setHold('touch', true), { passive: true, signal });
          this.viewport.addEventListener('touchend', () => this.setHold('touch', false), { passive: true, signal });
          this.viewport.addEventListener('touchcancel', () => this.setHold('touch', false), { passive: true, signal });
        }
        this.addEventListener('focusin', (e) => {
          const t = e.target;
          if (t && t.matches && t.matches(':focus-visible') && !t.closest('[data-rl-toggle]')) {
            this.setHold('focus', true);
          }
        }, { signal });
        this.addEventListener('focusout', () => this.setHold('focus', false), { signal });

        document.addEventListener('visibilitychange', () => {
          this.pageVisible = !document.hidden;
          this.schedule();
        }, { signal });

        const onMq = () => this.measure();
        this.mobileMq.addEventListener('change', onMq, { signal });
        this.reducedMq.addEventListener('change', () => {
          if (this.reducedMq.matches) this.userPaused = true;
          this.updateToggle();
          this.schedule();
        }, { signal });

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.inView = entries.some((en) => en.isIntersecting);
            this.schedule();
          }, { threshold: 0.1 });
          this.io.observe(this);
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => {
            cancelAnimationFrame(this.roRaf);
            this.roRaf = requestAnimationFrame(() => this.measure());
          });
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.measure(), { signal });
        }

        this.updateToggle();
        this.measure();
      }

      destroy() {
        this.ready = false;
        clearTimeout(this.timer);
        cancelAnimationFrame(this.raf);
        cancelAnimationFrame(this.roRaf);
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
      }

      /* ---------- state helpers ---------- */
      isCarousel() {
        const key = this.mobileMq.matches ? 'mobile' : 'desktop';
        return this.dataset[key] === 'true';
      }

      maxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      stepSize() {
        const s = this.slides;
        if (s.length > 1) {
          const d = s[1].offsetLeft - s[0].offsetLeft;
          if (d > 0) return d;
        }
        return s[0] ? s[0].offsetWidth : this.track.clientWidth;
      }

      current() {
        if (this.count <= 1) return 0;
        const left = this.track.scrollLeft;
        if (left >= this.maxScroll() - this.TOL) return this.count - 1;
        return Math.min(this.count - 1, Math.max(0, Math.round(left / this.stepSize())));
      }

      /* ---------- layout / ui ---------- */
      measure() {
        if (!this.ready) return;

        if (!this.isCarousel()) {
          this.count = 0;
          this.setUiHidden(true);
          this.schedule();
          return;
        }

        const max = this.maxScroll();
        const step = this.stepSize();
        this.count = max <= this.TOL || step <= 0 ? 1 : Math.ceil((max - this.TOL) / step) + 1;

        this.setUiHidden(this.count <= 1);
        this.buildDots();
        this.update();
        this.schedule();
      }

      setUiHidden(hide) {
        if (this.prevBtn) this.prevBtn.hidden = hide;
        if (this.nextBtn) this.nextBtn.hidden = hide;
        if (this.bar) this.bar.hidden = hide;
      }

      buildDots() {
        if (!this.dotsEl) return;
        if (this.count <= 1) {
          this.dotsEl.textContent = '';
          return;
        }
        if (this.dotsEl.children.length === this.count) return;

        this.dotsEl.textContent = '';
        const frag = document.createDocumentFragment();
        for (let i = 0; i < this.count; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'rl-carousel__dot';
          b.dataset.rlDot = String(i);
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          frag.appendChild(b);
        }
        this.dotsEl.appendChild(frag);
      }

      queueUpdate() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => this.update());
      }

      update() {
        this.raf = null;
        if (!this.ready || this.count <= 1) return;

        const idx = this.current();

        if (this.dotsEl) {
          Array.from(this.dotsEl.children).forEach((dot, i) => {
            if (i === idx) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        if (this.prevBtn) this.prevBtn.disabled = !this.loop && idx <= 0;
        if (this.nextBtn) this.nextBtn.disabled = !this.loop && idx >= this.count - 1;
      }

      /* ---------- navigation ---------- */
      goTo(i) {
        if (this.count <= 1) return;
        const target = Math.max(0, Math.min(this.count - 1, i));
        const left = target >= this.count - 1 ? this.maxScroll() : target * this.stepSize();
        this.track.scrollTo({ left, behavior: this.reducedMq.matches ? 'auto' : 'smooth' });
      }

      next() {
        const i = this.current();
        if (i >= this.count - 1) {
          if (this.loop) this.goTo(0);
        } else {
          this.goTo(i + 1);
        }
      }

      prev() {
        const i = this.current();
        if (i <= 0) {
          if (this.loop) this.goTo(this.count - 1);
        } else {
          this.goTo(i - 1);
        }
      }

      /* ---------- show more (mobile grid) ---------- */
      showMore() {
        this.dataset.mobileExpanded = 'true';
        if (this.showMoreBtn) {
          this.showMoreBtn.setAttribute('aria-expanded', 'true');
        }
        const hiddenSlides = this.track ? this.track.querySelectorAll('.rl-carousel__slide--mobile-hidden') : [];
        if (hiddenSlides.length > 0) {
          const firstNewSlide = hiddenSlides[0];
          const focusTarget = firstNewSlide.querySelector('a, button, [tabindex="0"]') || firstNewSlide;
          if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus({ preventScroll: true });
          }
        }
        this.measure();
      }

      /* ---------- autoplay ---------- */
      canPlay() {
        return (
          this.autoplay &&
          this.isCarousel() &&
          this.count > 1 &&
          !this.userPaused &&
          this.holds.size === 0 &&
          this.inView &&
          this.pageVisible
        );
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.ready || !this.canPlay()) return;
        this.timer = setTimeout(() => {
          this.next();
          this.schedule();
        }, this.speed);
      }

      setHold(name, on) {
        if (on) this.holds.add(name);
        else this.holds.delete(name);
        this.schedule();
      }

      setUserPaused(value) {
        this.userPaused = value;
        this.updateToggle();
        this.schedule();
      }

      updateToggle() {
        const playing = this.autoplay && !this.userPaused;
        if (this.toggleBtn) {
          this.toggleBtn.dataset.playing = String(playing);
          this.toggleBtn.setAttribute('aria-label', playing ? 'Pause autoplay' : 'Play autoplay');
        }
        if (this.autoplay) this.track.setAttribute('aria-live', playing ? 'off' : 'polite');
      }
    }

    customElements.define('product-list-carousel', ProductListCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
